(() => {
  "use strict";

  /*
   * Centroute Airport Customizer
   * Browser Shortcut Protection
   *
   * This is a deterrence layer only.
   *
   * It blocks common keyboard shortcuts for:
   *
   * - Save Page
   * - Print / Save as PDF
   * - View Source
   * - Chrome DevTools
   * - Safari Web Inspector
   *
   * Browser menus and other developer methods
   * cannot be completely disabled by a webpage.
   */

  const CUSTOMIZER_SELECTOR =
    "[data-airport-customizer]";

  function customizerExists() {
    return Boolean(
      document.querySelector(
        CUSTOMIZER_SELECTOR
      )
    );
  }

  function normalizeKey(event) {
    return String(
      event.key || ""
    ).toLowerCase();
  }

  function isBlockedShortcut(event) {
    if (!customizerExists()) {
      return false;
    }

    const key =
      normalizeKey(event);

    const command =
      event.metaKey;

    const control =
      event.ctrlKey;

    const option =
      event.altKey;

    const shift =
      event.shiftKey;

    /*
     * F12 / Fn + F12
     *
     * Common Windows/Linux DevTools shortcut.
     * Some Mac keyboards may also expose F12
     * depending on function-key settings.
     */
    if (key === "f12") {
      return true;
    }

    /*
     * Save Page
     *
     * Mac:
     * Command + S
     *
     * Windows/Linux:
     * Control + S
     *
     * Also catches Shift variants such as
     * Save As where supported.
     */
    if (
      (command || control) &&
      key === "s"
    ) {
      return true;
    }

    /*
     * Print
     *
     * Mac:
     * Command + P
     *
     * Windows/Linux:
     * Control + P
     *
     * Step 4 remains our fallback if someone
     * reaches Print through the browser menu.
     */
    if (
      (command || control) &&
      key === "p"
    ) {
      return true;
    }

    /*
     * View Page Source
     *
     * Covers:
     *
     * Control + U
     * Command + U
     * Command + Option + U
     */
    if (
      (command || control) &&
      key === "u"
    ) {
      return true;
    }

    /*
     * Chrome / Safari DevTools on Mac
     *
     * Command + Option + I
     * Command + Option + J
     * Command + Option + C
     */
    if (
      command &&
      option &&
      ["i", "j", "c"].includes(
        key
      )
    ) {
      return true;
    }

    /*
     * Chrome also supports
     * Command + Shift + C
     * for element inspection on Mac.
     */
    if (
      command &&
      shift &&
      !option &&
      key === "c"
    ) {
      return true;
    }

    /*
     * Chrome DevTools on
     * Windows / Linux
     *
     * Control + Shift + I
     * Control + Shift + J
     * Control + Shift + C
     */
    if (
      control &&
      shift &&
      ["i", "j", "c"].includes(
        key
      )
    ) {
      return true;
    }

    return false;
  }

  function blockShortcut(event) {
    if (
      !isBlockedShortcut(
        event
      )
    ) {
      return;
    }

    event.preventDefault();

    event.stopPropagation();

    event.stopImmediatePropagation();
  }

  /*
   * Capture-phase listener gives the
   * protection the earliest opportunity
   * to intercept keyboard events while
   * focus is inside the webpage.
   */
  window.addEventListener(
    "keydown",
    blockShortcut,
    true
  );
})();